import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { Skeleton } from '@picsart/design-system/components/Skeleton';
import useStyles from './styles';

const ColorMeaningsFallback = () => {
  const styles = useStyles();
  return (
    <div className={styles.rootFallback}>
      <div className={styles.headerFallback}>
        <Skeleton className={styles.iconFallback} />
        <Skeleton className={styles.titleFallback} />
        <Skeleton className={styles.descriptionFallback} />
        <Skeleton className={styles.inputFallback} />
        <div className={styles.tabsFallback}>
          {new Array(8).fill('').map((item, index) => (
            <Skeleton key={index} className={styles.tabFallback} />
          ))}
        </div>
      </div>
      <HorizontalContainer>
        <div className={styles.colorsFallback}>
          {new Array(40).fill('').map((item, index) => (
            <Skeleton key={index} className={styles.colorFallback} />
          ))}
        </div>
      </HorizontalContainer>
    </div>
  );
};

export default ColorMeaningsFallback;
